<div class="row justify-content-center">
  <div class="col-12 col-sm-10 col-md-6 col-lg-5">
    <ng-container *ngIf="starterProduct; else starterUnavailable">
      <div class="card starter-card bg-linear text-center border-0">
        <div class="card-body py-4">
          <h6 class="text-uppercase mb-2">
            {{ 'STARTER_PLAN.CARD_TITLE' | translate }}
            (<span>{{ getLangName() | translate }}</span>)
          </h6>
          <p class="small text-muted mb-3">
            {{ 'STARTER_PLAN.CARD_CREDITS' | translate }}
          </p>
          <h2 class="mb-1">
            {{ starterProduct?.price?.value | number: '1.2-2' }}
            <span class="currency">
              {{ starterProduct?.price?.currency | uppercase }}
            </span>
          </h2>
          <p class="text-muted small mb-4">
            {{ getPricePerLesson() }}
            {{ 'COL.COURSES.PRODUCTS.PLANS.PER_LESSON' | translate }}
          </p>
          <button
            class="btn btn-primary px-5"
            (click)="addStarterToCart()"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasCart"
          >
            {{ 'BUTTON.BUY' | translate }}
          </button>
        </div>
      </div>
    </ng-container>
    <ng-template #starterUnavailable>
      <div class="text-center text-muted small">
        {{ 'STARTER_PLAN.NOT_AVAILABLE' | translate }}
      </div>
    </ng-template>
  </div>
</div>
